module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('router-view', {
    attrs: {
      "orders": _vm.orders
    },
    on: {
      "toggleShowDetail": _vm.toggleShowDetail
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1569afc2!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/subPages/MyPage/Order.vue
// module id = 672
// module chunks = 0